import PropTypes from "prop-types";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import classnamesBind from "classnames/bind";

import styles from "./PlusPill.scss";

const classnames = classnamesBind.bind(styles);

const PlusPill = ({ number, additionalClasses }) => {
  const { getTranslation } = useRuntimeConstants();

  return (
    <span
      className={classnames(styles.container, additionalClasses)}
      data-testid="plusPill"
      aria-label={getTranslation("pdp_styled_for_you_accessibility_pill", {
        number,
      })}
    >
      +{number}
    </span>
  );
};

PlusPill.propTypes = {
  number: PropTypes.string.isRequired,
  additionalClasses: PropTypes.string,
};

export default PlusPill;
